/*!
 * Copyright (C) Microsoft Corporation. All rights reserved.
 */
export var NameKind;
(function (NameKind) {
    NameKind[NameKind["HostSymbol"] = 0] = "HostSymbol";
    NameKind[NameKind["Variable"] = 1] = "Variable";
    NameKind[NameKind["Function"] = 2] = "Function";
})(NameKind || (NameKind = {}));
//# sourceMappingURL=PowerFxSyntaxTypes.js.map